<template>
  <v-layout column>

    <h2>Medicamentos</h2>
    <h3 class="mb-4 text-secondary">Medicines</h3>

    <h3>Favor preencher caso a criança esteja sob tratamento:</h3>
    <h3 class="mb-4">Please fill if the child is under a physicians care for a medical condition:</h3>

    <h3>A ESCOLA ESTÁ AUTORIZADA A MINISTRAR TYLENOL. / THE SCHOOL IS PERMITTED TO GIVE TYLENOL.</h3>
    <v-radio-group v-model="resource.form.can_apply_tylenol" row>
      <v-radio label="SIM/YES" :value="true"></v-radio>
      <v-radio label="NÃO/NO" :value="false"></v-radio>
    </v-radio-group>

    <h3>A ESCOLA ESTÁ AUTORIZADA A MINISTRAR ALIVIUM. / THE SCHOOL IS PERMITTED TO GIVE ALIVIUM.</h3>
    <v-radio-group v-model="resource.form.can_apply_alivium" row>
      <v-radio label="SIM/YES" :value="true"></v-radio>
      <v-radio label="NÃO/NO" :value="false"></v-radio>
    </v-radio-group>

    <h3>A ESCOLA ESTÁ AUTORIZADA A MINISTRAR DIPIRONA. / THE SCHOOL IS PERMITTED TO GIVE DIPYRONE.</h3>
    <v-radio-group v-model="resource.form.can_apply_dipyrone" row>
      <v-radio label="SIM/YES" :value="true"></v-radio>
      <v-radio label="NÃO/NO" :value="false"></v-radio>
    </v-radio-group>

    <h3>A ESCOLA ESTÁ AUTORIZADA A USAR OUTROS MEDICAMENTOS, CASO NECESSÁRIO. / THE SCHOOL IS AUTHORIZED TO USE OTHER MEDICINES IF NECESSARY.</h3>
    <v-layout row align-center>
      <v-layout row>
        <v-radio-group v-model="resource.form.can_be_medicated" row>
          <v-radio label="SIM/YES" :value="true"></v-radio>
          <v-radio label="NÃO/NO" :value="false"></v-radio>
        </v-radio-group>
        <v-flex d-flex xs12 sm6 md6>
          <v-text-field
            outline
            :disabled="!resource.form.can_be_medicated"
            v-model="resource.form.can_be_medicated_details"
            :rules="resource.form.can_be_medicated ? required : []"
            :background-color="resource.form.can_be_medicated ? '' : '#ccc'"
            label="QUAIS? / WHICH ONES?"
          />
        </v-flex>
      </v-layout>
    </v-layout>

    <h3>O(A) ALUNO(A) FAZ USO DE ALGUM REMÉDIO QUE A ESCOLA PRECISA ADMINISTRAR EM HORÁRIOS ESPECÍFICOS? / DOES THE STUDENT USE ANY MEDICATION THAT THE SCHOOL NEEDS TO ADMINISTER AT SPECIFIC TIMES?</h3>
    <v-layout row align-center>
      <v-layout row>
        <v-radio-group v-model="resource.form.should_be_medicated_time" row>
          <v-radio label="SIM/YES" :value="true"></v-radio>
          <v-radio label="NÃO/NO" :value="false"></v-radio>
        </v-radio-group>
        <v-flex d-flex xs12 sm6 md6>
          <v-text-field
            outline
            :disabled="!resource.form.should_be_medicated_time"
            v-model="resource.form.should_be_medicated_time_details"
            :rules="resource.form.should_be_medicated_time ? required : []"
            :background-color="resource.form.should_be_medicated_time ? '' : '#ccc'"
            label="QUAIS HORÁRIOS? / WHAT TIMES?"
          />
        </v-flex>
      </v-layout>
    </v-layout>
  </v-layout>
</template>

<script>
/**
 * @group Form
 * Componente de form para dados de Saúde do estudante
 */
export default {
  name: 'FormMedicine',

  inject: ['resource'],

  data: () => ({
    required: [v => !!v || 'Campo obrigatório/Field is required']
  }),

  computed: {
    resource () {
      return this.resource
    }
  }
}
</script>
